import Parser from '../parser/index'

import NodeTypes from '../share/NodeTypes'

export default class {
  constructor() {
    this._parser = new Parser()
    this._dom = null
    this._stack = null

    this.handleStart = this.handleStart.bind(this)
    this.handleOpen = this.handleOpen.bind(this)
    this.handleText = this.handleText.bind(this)
    this.handleComment = this.handleComment.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleDone = this.handleDone.bind(this)

    this._parser
      .on("start", this.handleStart)
      .on("open", this.handleOpen)
      .on("text", this.handleText)
      .on("comment", this.handleComment)
      .on("close", this.handleClose)
      .on("done", this.handleDone)
  }

  handleStart() {
    this._dom = []
    this._stack = []
  }

  handleOpen(name, attributes, selfClosing) {
    let node = {
      type: NodeTypes.ELEMENT_NODE,
      name,
      value: null,
      children: [],
      attributes
    }
    Object.defineProperty(node, "raw", {
      value: null,
      enumerable: false,
      configurable: true,
      writable: true
    })
    if (this._stack.length > 0) {
      this._stack[this._stack.length - 1].children.push(node)
    } else {
      this._dom.push(node)
    }
    if (!selfClosing) {
      this._stack.push(node)
    }
  }

  handleText(text) {
    let node = {
      type: NodeTypes.TEXT_NODE,
      name: "#text",
      value: text,
      children: [],
      attributes: {},
    }
    Object.defineProperty(node, "raw", {
      value: null,
      enumerable: false,
      configurable: true,
      writable: true
    })
    if (this._stack.length > 0) {
      this._stack[this._stack.length - 1].children.push(node)
    } else {
      this._dom.push(node)
    }
  }

  handleComment(text) {
    let node = {
      type: NodeTypes.TEXT_NODE,
      name: "#comment",
      value: text,
      children: [],
      attributes: {},
    }
    Object.defineProperty(node, "raw", {
      value: null,
      enumerable: false,
      configurable: true,
      writable: true
    })
    if (this._stack.length > 0) {
      this._stack[this._stack.length - 1].children.push(node)
    } else {
      this._dom.push(node)
    }
  }

  handleClose(name, selfClosing) {
    if (!selfClosing) {
      this._stack.pop()
    }
  }

  handleDone() {
    this._stack.length = 0
  }

  parse(html) {
    this._parser.parse(html)

    return this._dom
  }
}


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/dinnerSvg/dom/index.js